module.exports = __webpack_public_path__ + "static/flags/LY-894f5759551a4d3ca4fc25968e8db505.gif";